import { Image } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledInlineContact from './InlineContact.style.js';

/* eslint-disable react/no-array-index-key */

const InlineContact = ({
  label,
  mail,
  location,
  user,
  hideUserMail
}) => {
  if (user || location) {
    const contactUser = user && user.length > 0 ? user[0] : null;
    const data = {
      label: contactUser ? contactUser.fullName : label,
      mail: contactUser ? contactUser.email : mail,
      location: contactUser ? contactUser.locations : location,
      userImage: contactUser ? contactUser.photo : null,
      userPosition: contactUser ? contactUser.position : null,
      userAlternativePosition: contactUser ? contactUser.alternativePosition : null,
      userPhoneNumber: contactUser ? contactUser.phoneNumber : null,
      userSocialLinks: contactUser ? contactUser.socialLinks : null
    };
    return /*#__PURE__*/React$1.createElement(StyledInlineContact, {
      hasUser: contactUser
    }, data.userImage && /*#__PURE__*/React$1.createElement("div", {
      className: "inlineContact__author-image-wrapper"
    }, /*#__PURE__*/React$1.createElement(Image, {
      ratio: "1:1",
      src: data.userImage.url,
      srcset: data.userImage.srcset,
      className: "inlineContact__author-image",
      alt: data.userImage.alt || data.userImage.fullName
    })), /*#__PURE__*/React$1.createElement("div", {
      className: "inlineContact__wrapper"
    }, /*#__PURE__*/React$1.createElement(Typography$1, {
      as: "h3",
      variant: "subline"
    }, data.label), data.userPosition || data.userAlternativePosition ? /*#__PURE__*/React$1.createElement(Typography$1, {
      className: "inlineContact__author-position",
      variant: "small"
    }, data.userPosition || data.userAlternativePosition) : null, data.location && data.location.length > 0 && data.location.map((item, index) => {
      const {
        address: {
          parts: {
            address,
            number,
            postcode,
            city
          }
        },
        phoneNumber
      } = item;
      return /*#__PURE__*/React$1.createElement(React$1.Fragment, {
        key: index
      }, /*#__PURE__*/React$1.createElement(Typography$1, null, `${address} ${number}`), /*#__PURE__*/React$1.createElement(Typography$1, null, `${postcode} ${city}`), !data.userPhoneNumber && phoneNumber && phoneNumber.trim() !== '' && /*#__PURE__*/React$1.createElement("div", {
        className: "inlineContact__link"
      }, /*#__PURE__*/React$1.createElement(Link$1, {
        href: `tel:${phoneNumber}`,
        component: "a",
        icon: "external",
        type: "secondary",
        "aria-label": `Call ${phoneNumber}`
      }, phoneNumber)));
    }), data.userPhoneNumber && data.userPhoneNumber.trim() !== '' && /*#__PURE__*/React$1.createElement("div", {
      className: "inlineContact__link"
    }, /*#__PURE__*/React$1.createElement(Link$1, {
      href: `tel:${data.userPhoneNumber}`,
      component: "a",
      icon: "external",
      type: "secondary",
      "aria-label": `Call ${data.userPhoneNumber}`
    }, data.userPhoneNumber)), !hideUserMail || mail ? /*#__PURE__*/React$1.createElement("div", {
      className: "inlineContact__link"
    }, /*#__PURE__*/React$1.createElement(Link$1, {
      href: `mailto:${mail || data.mail}`,
      component: "a",
      icon: "external",
      type: "secondary"
    }, mail || data.mail)) : null, data.userSocialLinks && data.userSocialLinks.length > 0 && /*#__PURE__*/React$1.createElement("div", {
      className: "inlineContact__author-social-media"
    }, /*#__PURE__*/React$1.createElement("ul", null, data.userSocialLinks.map(link => link && /*#__PURE__*/React$1.createElement("li", {
      key: link.socialService
    }, /*#__PURE__*/React$1.createElement(Link$1, {
      noHover: true,
      className: link.isActive ? 'is-active' : '',
      href: link.href,
      target: link.target,
      rel: link.rel,
      icon: null,
      "aria-label": `Visit ${data.label || 'us'} on ${link.socialService.charAt(0).toUpperCase() + link.socialService.slice(1)}`
    }, /*#__PURE__*/React$1.createElement(Icon$1, {
      icon: link.socialService,
      alignment: "none"
    }))))))));
  }

  return /*#__PURE__*/React$1.createElement(StyledInlineContact, null, /*#__PURE__*/React$1.createElement("div", {
    className: "inlineContact__wrapper"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    as: "h3",
    variant: "subline"
  }, label), /*#__PURE__*/React$1.createElement("div", {
    className: "inlineContact__link"
  }, /*#__PURE__*/React$1.createElement(Link$1, {
    href: `mailto:${mail}`,
    component: "a",
    icon: "external",
    type: "secondary"
  }, mail))));
};

InlineContact.propTypes = {
  label: PropTypes$1.string,
  mail: PropTypes$1.string.isRequired,
  location: PropTypes$1.arrayOf(PropTypes$1.shape({
    address: {
      parts: {
        address: PropTypes$1.string,
        number: PropTypes$1.string,
        postCode: PropTypes$1.string,
        city: PropTypes$1.string
      }
    },
    phoneNumber: PropTypes$1.string
  })),
  user: PropTypes$1.arrayOf(PropTypes$1.shape()),
  hideUserMail: PropTypes$1.bool
};
InlineContact.defaultProps = {
  label: null,
  location: null,
  user: null,
  hideUserMail: false
};

export default InlineContact;
